// import featureImg from "../assets/featureImg.png";
// import featureAcc from "../assets/featureAcc.png";
// import feature1 from "../assets/feature1.png";
// import featureM from "../assets/featureM.png";
// import featureL from "../assets/featureL.png";
// import featureP from "../assets/featureP.png";

const featureContent = [
  {
    slug: "accounting",
    title: "Accounting & Financial Tools",
    description: "Streamline Your Accounts with AI Precision",
    // image: featureImg,
    buttonLabel: "Start Streamlining Your Accounts",
    // details:
   
    sections: [
      {
        title: "Rent Tracking",
        subtitle: "Monitor Rent Payments and Pending Dues",
        content:
          "Track rent payments and overdue amounts in real-time for better financial management, ensuring timely collections.",
        // image: featureAcc,
        textOnLeft: false,
      },
      {
        title: "Expense Management",
        subtitle: "Effortlessly Record and Organize Expenses",
        content:
          "Keep a detailed record of all property-related expenses with our AI-driven tools, providing clear visibility into your accounts.",
        // image: featureAcc,
        textOnLeft: true,
      },
      {
        title: "Invoicing & Reports",
        subtitle: "Generate Professional Financial Reports",
        content:
          "Simplify your accounting with automated, AI-enhanced reports and detailed transaction histories for auditing and reviews.",
        // image: featureAcc,
        textOnLeft: false,
      },
    ],
  },
  {
    slug: "maintenance",
    title: "Maintenance Management",
    description: "Efficiently Manage Property Maintenance with AI Automation",
    // image: featureM,
    buttonLabel: "Simplify Maintenance Requests",
    details:
      "Handle service requests, repairs, and facility management effortlessly with AI-powered maintenance tools.",
    sections: [
      {
        title: "Service Requests",
        subtitle: "Streamlined Tenant Maintenance Requests",
        content:
          "Tenants can easily submit and track maintenance requests through our platform, ensuring issues are addressed promptly.",
        // image: featureM,
        textOnLeft: false,
      },
      {
        title: "Facility Management",
        subtitle: "Efficiently Oversee Property Maintenance",
        content:
          "Organize and schedule maintenance tasks to reduce downtime and improve tenant satisfaction.",
        // image: featureM,
        textOnLeft: true,
      },
      {
        title: "Repairs & Service",
        subtitle: "Assign and Monitor Repairs with Ease",
        content:
          "Use AI-powered task management systems to assign and track repairs, ensuring timely completion and reducing tenant dissatisfaction.",
        // image: featureM,
        textOnLeft: false,
      },
    ],
  },
  {
    slug: "inventory",
    title: "Inventory and Leasing",
    description: "Optimize Asset and Lease Management with AI Insights",
    // image: featureL,
    buttonLabel: "Manage Inventory with Ease",
    details:
      "Optimize your asset and lease management with AI-powered insights and tools.",
    sections: [
      {
        title: "Asset Tracking",
        subtitle: "Monitor and Manage Property Assets",
        content:
          "Keep track of all property assets and link them to maintenance tasks for better organization and efficiency.",
        // image: featureL,
        textOnLeft: false,
      },
      {
        title: "Lease Management",
        subtitle: "Simplify Lease Agreements",
        content:
          "Efficiently handle lease creation, updates, and tenant requests, ensuring compliance and smooth processes.",
        // image: featureL,
        textOnLeft: true,
      },
      {
        title: "Move-In/Out & Multi-Tenancy",
        subtitle: "Streamline Tenant Transitions",
        content:
          "Manage tenant move-ins, move-outs, and multiple tenants with ease, reducing vacancies and improving tenant satisfaction.",
        // image: featureL,
        textOnLeft: false,
      },
    ],
  },
  {
    slug: "portals",
    title: "Organization, Owners & Tenant Portals",
    description: "Unified AI & SaaS Access for All Stakeholders",
    // image: featureP,
    buttonLabel: "Join Our Unified Portal",
    details:
      "Bring tenants, property managers, and owners together on one platform to simplify communication and management.",
    sections: [
      {
        title: "Account Management",
        subtitle: "Track and Manage Tenant Accounts",
        content:
          "Allow tenants to update personal details while property managers track lease statuses and tenant profiles effortlessly.",
        // image: featureP,
        textOnLeft: false,
      },
      {
        title: "Rent Payments",
        subtitle: "Simplify Online Payments",
        content:
          "Tenants can make secure online payments while property managers automate rent collection and tracking.",
        // image: featureP,
        textOnLeft: true,
      },
      {
        title: "Leasing & Communication",
        subtitle: "Streamline Leasing Processes",
        content:
          "Enable tenants to manage lease renewals or terminations while property managers create and track leases efficiently.",
        // image: featureP,
        textOnLeft: false,
      },
    ],
  },
  {
    slug: "analytics",
    title: "Analytics & Reporting",
    description: "Data-Driven AI Insights for Strategic Decisions",
    // image: feature1,
    buttonLabel: "Gain Insights with Analytics",
    details:
      "Leverage AI-driven analytics for performance tracking, maintenance metrics, tenant behaviors, and financial insights.",
    sections: [
      {
        title: "Performance Tracking",
        subtitle: "Evaluate Property Efficiency",
        content:
          "Use AI-powered performance metrics to assess property and rental unit efficiency for informed decision-making.",
        // image: feature1,
        textOnLeft: false,
      },
      {
        title: "Occupancy Trends",
        subtitle: "Monitor Occupancy and Vacancy Rates",
        content:
          "Identify patterns and optimize rental strategies with advanced analytics tools.",
        // image: feature1,
        textOnLeft: true,
      },
      {
        title: "Lease Performance",
        subtitle: "Track Lease Renewals and Expirations",
        content:
          "Proactively manage lease agreements and reduce turnover rates using AI-driven insights.",
        // image: feature1,
        textOnLeft: false,
      },
    ],
  },
];

export default featureContent;
